/**
 * Welcher Zustand die Job-Status-Zeile der Seitenleiste zeigt (A3-05).
 * Bis WP6 galt "kein Problem bekannt" als "alles gesund": scheiterte die
 * Pruefung selbst (check-job-failures 4xx/5xx), war `health` undefined und die
 * Zeile meldete gruen. Nicht gemessen ist nicht in Ordnung.
 */
export type JobHealthView = 'loading' | 'running' | 'issues' | 'healthy' | 'unknown';

export function deriveJobHealthView(input: {
  healthLoading: boolean;
  jobsLoading: boolean;
  healthError: boolean;
  health: { health?: { healthy: boolean } } | undefined;
  activeJobs: number | undefined;
}): JobHealthView {
  if (input.healthLoading || input.jobsLoading) return 'loading';
  if (input.activeJobs && input.activeJobs > 0) return 'running';
  if (input.healthError || !input.health?.health) return 'unknown';
  return input.health.health.healthy ? 'healthy' : 'issues';
}
